import React, {useCallback, useState} from 'react';
import {Checkbox, Flex} from "@chakra-ui/react";
import docs from "../utils/docs.json";

const AgreeAndContinue = props => {

    const [isAgree, setIsAgree] = useState(true);

    const agreeProcess = useCallback((value)=>{
        setIsAgree(value);
        if(props?.onChangeAgree) props.onChangeAgree(isAgree);
    },[isAgree]);

    return (
        <Flex direction='vertical' style={{backgroundColor: "orange", padding: "20px", borderRadius: "20px"}}>
            <Checkbox
                isChecked={isAgree}
                onChange={(event) => agreeProcess(event?.target?.checked)}>
                “Spunta obbligatoria”
                Concedi il diritto di utilizzo delle informazioni caricate, dei testi (originali) e delle immagini (originali) alla Dimensione Explorer S.r.l. per qualsiasi tipo di utilizzo compreso quello commerciale.
            </Checkbox>
            <a className='' href={docs?.full.docs} target="_blank" rel="noreferrer">
                <p>Apri il modulo</p>
            </a>
        </Flex>
    );
};



export default AgreeAndContinue;
